import { Stack, Typography, styled } from '@mui/material';
import {
  differenceInCalendarDays,
  format,
  isSameYear,
  isToday,
  isYesterday,
} from 'date-fns';
import { useMemo } from 'react';
import type { AiChat } from 'src/@types/ai';
// import {
//   NavAccordionDetails,
//   NavAccordionSummary,
// } from 'src/features/Navbar/NavAccordion';
// import { NavAccordionPersisted } from 'src/features/Navbar/NavAccordionPersisted';
// import { NavActionButton } from 'src/features/Navbar/NavActionButton/NavActionButton';
import { useLocales } from 'src/locales';
// import { UIFeature } from 'src/state/ui/types';
import { ConversationAiItem } from './ConversationAiItem';

export const ConversationsList = ({
  conversations,
  shouldNavigate,
}: { conversations: AiChat[]; shouldNavigate?: boolean }) => {
  const { translate, currentLang } = useLocales();

  const groupedConversations = useMemo(() => {
    if (!conversations) return [];
    const a = new Map<string, AiChat[]>();
    conversations.forEach((chat) => {
      const createdAt = new Date(chat.createdAt);
      let key: string;
      const today = new Date();

      if (isToday(createdAt)) {
        key = translate('copera_ai.conversation_list.today');
      } else if (isYesterday(createdAt)) {
        key = translate('copera_ai.conversation_list.yesterday');
      } else if (differenceInCalendarDays(today, createdAt) <= 7) {
        key = translate('copera_ai.conversation_list.last_7_days');
      } else if (isSameYear(createdAt, today)) {
        key = format(createdAt, 'MMMM', { locale: currentLang.dateValue });
      } else {
        key = format(createdAt, 'yyyy', { locale: currentLang.dateValue });
      }
      if (!a.has(key)) {
        a.set(key, []);
      }
      a.get(key)!.push(chat);
    });
    return Array.from(a.entries()).map(([title, conversations]) => ({
      title,
      conversations,
    }));
  }, [conversations, translate, currentLang.dateValue]);

  return (
    <StyledContainer>
      {/* <NavAccordionPersisted feature={UIFeature.topics}>
        <NavAccordionSummary>
          <Typography variant="subtitle2" whiteSpace="nowrap">
            {translate('shared.labels.topics')}
          </Typography>
          <NavActionButton
            icon="tabler:plus"
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
        </NavAccordionSummary>
        <NavAccordionDetails>
          Aqui vai o componente com a lista de tópicos 
        </NavAccordionDetails>
      </NavAccordionPersisted> */}
      <StyledConversationListContainer>
        {groupedConversations.map(({ title, conversations: chats }) => (
          <Stack key={title} gap={0.5}>
            <Stack px={1.5} py={0.5}>
              <Typography variant="subtitle2">{title}</Typography>
            </Stack>
            {chats.map((c) => (
              <ConversationAiItem
                key={c._id}
                chat={c}
                shouldNavigate={shouldNavigate}
              />
            ))}
          </Stack>
        ))}
      </StyledConversationListContainer>
    </StyledContainer>
  );
};

const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(1.5),
}));

const StyledConversationListContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  // borderTop: `1px solid ${theme.palette.divider}`,
  // paddingTop: theme.spacing(1.5),
  gap: theme.spacing(1.5),
}));
